import { Component, ElementRef, EventEmitter, OnInit, AfterViewInit, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-dice-button',
  templateUrl: './dice-button.component.html',
  styleUrls: ['./dice-button.component.scss']
})
export class DiceButtonComponent implements OnInit, AfterViewInit {
  @Input() darkBackground = false;

  @Output() buttonClick: EventEmitter<void> = new EventEmitter()

  @ViewChild('diceSVG') svgElement: ElementRef;
  
  rotationAngle: number = 0;
  diceColor: string = "000000";


  constructor() { }

  ngOnInit(): void {
    if (this.darkBackground) this.diceColor = "ffffff";
  }

  ngAfterViewInit() {
    if (this.darkBackground) this.svgElement.nativeElement.setAttribute('fill', 'white');
  }

  onClick() {
    this.rotationAngle += 45;
    this.svgElement.nativeElement.style.transform = `rotate(${this.rotationAngle}deg)`;
    this.buttonClick.emit()
  }

}
